import type { ContentObjectDetail, ContentObjectList } from 'models';
import { type ReactNode, useCallback } from 'react';
import { Form, FormActions, Modal, RichTextInput, message } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { CommunitySelectWithUserProfilePhoto } from 'features/communities/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useCommunityMentions } from 'features/communities/hooks';
import { useRepostContentObjectMutation } from '../../../../queries';

type FormValues = {
  community: { label: string; value: string };
  htmlContent?: string;
  textContent?: string;
};

type P = {
  isOpened: boolean;
  item: ContentObjectDetail | ContentObjectList;
  onCancel: () => void;
  // TODO: preview is passed in as a prop to avoid a circular dependency on content-object-preview. Fix properly in the future.
  preview: ReactNode;
};

const RepostModal = ({ isOpened, item, onCancel, preview }: P) => {
  const [form] = Form.useForm<FormValues>();
  const { isPending: isLoadingRepostObject, mutate: repostObject } = useRepostContentObjectMutation();
  const getCommunityId = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- Antd's FormInstance.getFieldValue returns any
    () => (form.getFieldValue('community') as FormValues['community'] | undefined)?.value,
    [form],
  );
  const handleOnRequestMentions = useCommunityMentions(getCommunityId);

  const handleFormFinish = (values: FormValues) => {
    repostObject(
      {
        communityId: values.community.value,
        htmlContent: values.htmlContent,
        objectId: item.id,
        textContent: values.textContent,
      },
      {
        onSuccess() {
          message.success('Repost successful');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Repost" width="medium">
      <Modal.HugContent>
        <Form<FormValues> form={form} name="repostForm" noOptional onFinish={handleFormFinish}>
          <Form.Item<FormValues> name="community" rules={[{ required: true }]}>
            <CommunitySelectWithUserProfilePhoto />
          </Form.Item>
          <RichTextInput
            html={{
              label: 'Create post',
              mentions: handleOnRequestMentions,
              name: 'htmlContent',
              placeholder: 'Create post...',
            }}
            text={{ name: 'textContent' }}
          />
          {preview}
          <Modal.HugContent.Footer>
            <FormActions
              right={{ children: 'Cancel', onClick: onCancel }}
              submit={{ children: 'Repost', loading: isLoadingRepostObject }}
            />
          </Modal.HugContent.Footer>
        </Form>
      </Modal.HugContent>
    </Modal>
  );
};

export default RepostModal;
